import { Component, OnInit } from '@angular/core';
import { FunctionsService } from '../../services/functions.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-admin-home',
  templateUrl: './admin-home.component.html',
  styleUrls: ['./admin-home.component.scss']
})
export class AdminHomeComponent implements OnInit {

  constructor(private functionsService: FunctionsService, private router: Router) {
    if (functionsService.checkAdminIsConnected() == null) {
      this.router.navigate(['/admin/connexion']);
    } 
  }

  ngOnInit(): void {
    localStorage.removeItem('jobEditing');
  }

}
